import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './WhySosStaff.module.css';
import qualified from '../../assets/svg/qualified.svg';
import quick from '../../assets/svg/quick.svg';
import inclusive from '../../assets/svg/all_include.svg';
import discover from '../../assets/svg/discover.svg';
import make_money from '../../assets/svg/hassleFree.svg';
import HandShake from '../../assets/svg/HandShake.svg';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
function WhySosStaff(props) {
  const { history } = props;
  return (
    <>
      <div className={css.BusinessWorkWrap}>
        <div className={css.WhySosStaffMain}>
          <p className={css.heading}>
            {' '}
            <FormattedMessage id="WhySosOwner.Heading" />{' '}
          </p>
          <div className={css.WhySosStaffBoxContainer1}>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <img src={HandShake} alt="" />
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  {' '}
                  <FormattedMessage id="WhySosStaff.noString" />{' '}
                </h3>
                <p className={css.about}>
                  <FormattedMessage id="WhySosStaff.noStringAbout" />
                </p>
              </div>
            </div>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <img src={discover} alt="" />
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosStaff.discover" />{' '}
                </h3>
                <p className={css.about}>
                  {' '}
                  <FormattedMessage id="WhySosStaff.discoverAbout" />{' '}
                </p>
              </div>
            </div>
            <div className={css.boxItem}>
              <div className={css.icondiv}>
                <img src={make_money} alt="" />
              </div>
              <div className={css.boxItemDescContainer}>
                <h3 className={css.title}>
                  <FormattedMessage id="WhySosStaff.make_money" />
                </h3>
                <p className={css.about}>
                  <FormattedMessage id="WhySosStaff.make_moneyAbout" />{' '}
                </p>
              </div>
            </div>
          </div>
          <p className={css.WhySosStaffLastDesc}>
            <FormattedMessage id="WhySosStaff.WhySosStaffLastDesc" />{' '}
            <span
              className={css.WhySosStaffLastDescBtn}
              onClick={e => {
                e.stopPropagation();
                history.push(
                  createResourceLocatorString('SignupPage', routeConfiguration(), {}, {})
                );
              }}
            >
              <FormattedMessage id="WhySosStaff.WhySosStaffLastDescBtn" />
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default compose(withRouter)(WhySosStaff);
